import React, { Component } from "react";

import Places from "./Places";
import Recent from "./Recent";
import Suggestions from "./Suggestions";
import { Tabs, Tab } from "react-bootstrap";
import { I18n } from "react-redux-i18n";

import "../../../styles/components/map/mapboxExtensions/MapboxExtensions.scss";

class MapboxExtensions extends Component { 
  render() {
    return (
      <div id="mapboxExtensions" className={this.props.show ? "visible" : "hidden"}>
        <Tabs
          id="controlled-tab-example"
          activeKey={this.props.keyTab}
          onSelect={this.props.activeTab}
          className="my-3 pb-2"
        >
          <Tab eventKey="location" title={I18n.t("mapSearch_location")}></Tab>
          <Tab eventKey="chargingStations" title={I18n.t("notifications_chargingPoints")}></Tab>
        </Tabs>

        {!this.props.showAutocomplete && (
          <>
            {this.props.keyTab === "location" && this.props.recent.length !== 0 ?
              <>
                <Recent 
                  recent={this.props.recent} 
                  query={this.props.query} 
                  keyTab={this.props.keyTab} 
                />
                <hr />
              </>
            :
              this.props.recentCharger.length !== 0 &&
                <>
                  <Recent 
                    recent={this.props.recentCharger} 
                    query={this.props.query} 
                    keyTab={this.props.keyTab} />
                  <hr />
                </>
            }
          </>
        )}
        {!this.props.showAutocomplete && this.props.places.length !== 0 && this.props.keyTab === "location" && (
          <Places places={this.props.places} query={this.props.query} keyTab={this.props.keyTab} />
        )}
        {this.props.showAutocomplete && (
          <Suggestions
            suggestions={this.props.suggestions || []}
            selectedSuggestion={this.props.selectedSuggestion}
            query={this.props.query}
            keyTab={this.props.keyTab}
            openChargerDetail={this.props.openChargerDetail}
          />
        )}
      </div>
    );
  }
}

export default MapboxExtensions;
